import { create } from 'zustand';
import { dashboardAPI } from '../../api';
import { DashboardRH } from '../../types/dashboard/dashboardRH';
import { DashboardHome } from '../../types/dashboard/dashboardHome';

//STORES
export interface DashboardState {
  selectedModule: number
  erroDashboard: boolean,
  setErroDashboard: (erro: boolean) => void
  messageErro: string
  setMessageErro: (messageErro: string) => void
  setSelectedModule: (moduleId: number) => void

  loadingDashboard: boolean
  setLoadingDashboard: (loading: boolean) => void

  dashboardRH: DashboardRH | null
  setDashboardRH: (dashboard: DashboardRH | null) => void

  dashboardHome: DashboardHome | null
  setDashboardHome: (dashboard: DashboardHome | null) => void

  cleanDashboardStates: () => void
}

export const useDashboardStore = create<DashboardState>((set) => ({
  selectedModule: 0,
  setSelectedModule: async (moduleId: number) => {
    set(() => ({ erroDashboard: false }))
    set(() => ({ loadingDashboard: true }))
    if (moduleId === 11) {
      const rhDashboard = await dashboardAPI.getDashboardRH()
      if (rhDashboard.data && rhDashboard.statusCode === 200) {
        set(() => ({ dashboardRH: rhDashboard.data, selectedModule: moduleId }))
      }
      else {
        set(() => ({ erroDashboard: true, messageErro: rhDashboard.error?.Message ?? "Ocorreu um erro inesperado.", dashboardRH: null, selectedModule: 0 }))
      }
    }
    if (moduleId === 0) {
      const homeDashboard = await dashboardAPI.getDashboardHome()
      if (homeDashboard.data && homeDashboard.statusCode === 200) {
        set(() => ({ dashboardHome: homeDashboard.data, selectedModule: moduleId }))
      }
      else {
        set(() => ({ erroDashboard: true, messageErro: homeDashboard.error?.Message ?? "Ocorreu um erro inesperado.", dashboardHome: null, selectedModule: 0 }))
      }
    }

    set(() => ({ loadingDashboard: false }))
  },
  erroDashboard: false,
  setErroDashboard: (erro: boolean) => {
    set(() => ({ erroDashboard: erro }))
  },
  messageErro: "",
  setMessageErro: (messageErro: string) => {
    set(() => ({ messageErro: messageErro }))
  },
  loadingDashboard: false,
  setLoadingDashboard: (loading: boolean) => {
    set(() => ({ loadingDashboard: loading }))
  },

  dashboardRH: null,
  setDashboardRH: (dashboard: DashboardRH | null) => {
    set(() => ({ dashboardRH: dashboard }))
  },

  dashboardHome: null,
  setDashboardHome: (dashboard: DashboardHome | null) => {
    set(() => ({ dashboardHome: dashboard }))
  },

  cleanDashboardStates: () => {
    set(() => ({
      selectedModule: 0,
      dashboardRH: null,
      erroDashboard: false,
      messageErro: "",
      loadingDashboard: false
    }))
  }
}))